import React, {Component} from 'react';
import {Form, FormGroup, Input} from 'reactstrap';
import FromValidationError from "./FormValidationError";
import './Login.css';

export default class Login extends Component {

    render() {
        return (
            <Form id="loginForm" data-testid="loginForm">
                <FormGroup>
                    <Input
                        className={"generic-input gap-top-4"}
                        data-testid="loginForm.input.email"
                        type="email"
                        validations={['required', 'email']}
                        name="email"
                        value={this.props.email}
                        onChange={this.props.handleChange}
                        id="email"
                        placeholder="Email"
                    />
                    <FromValidationError field={this.props.validationErrors.email}/>
                </FormGroup>
                <FormGroup>
                    <Input
                        className="generic-input gap-top-4"
                        data-testid="loginForm.input.password"
                        type="password"
                        validations={['required']}
                        name="password"
                        value={this.props.password}
                        onChange={this.props.handleChange}
                        id="password"
                        placeholder="Password"
                    />
                    <FromValidationError field={this.props.validationErrors.password}/>
                </FormGroup>
                <div><p className={'error'} data-testid="loginForm.error">{this.props.error}</p></div>
                <div className="auth-form-buttons gap-top-4">
                    <button className="try-pi-btn auth-form-button-left" data-testid="loginForm.button.login" onClick={this.props.login}>LOGIN</button>
                    <button className="try-pi-btn auth-form-button-right" data-testid="loginForm.button.forgottenPassword" onClick={this.props.showForgottenPassword}>FORGOTTEN PASSWORD</button>
                </div>
            </Form>
        );
    }
}